export default __webpack_public_path__ + "static/media/sensotrend_connect_upload_data1.8f690519.png";